import React from "react";
import { IoIosCloseCircle, IoMdClose } from "react-icons/io";
import {
  FaGift,
  FaHandsHelping,
  FaRegCopy,
  FaUser,
  FaFlag,
  FaQrcode,
  FaCheck,
  FaGasPump,
  FaExternalLinkAlt
} from "react-icons/fa";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import {
  BiLogOutCircle,
  BiDollarCircle,
  BiChevronLeft,
  BiChevronRight,
  BiChevronDown,
  BiChevronUp,
  BiGitPullRequest
} from "react-icons/bi";
import {
  AiOutlineUnorderedList,
  AiFillSetting,
  AiOutlineStar,
  AiFillStar
} from "react-icons/ai";
import {
  MdDashboard,
  MdDelete,
  MdEdit,
  MdOutlineManageAccounts,
  MdAccountBox,
  MdMyLocation
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { FcTimeline } from "react-icons/fc";
import { GrTransaction } from "react-icons/gr";
import { RiUpload2Line } from "react-icons/ri";
import { IoMdMore } from "react-icons/io";
import { FiMoreVertical } from "react-icons/fi";
import { VscServerProcess } from "react-icons/vsc";
import { FaRegFileAlt } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { MdOutlineInfo } from "react-icons/md";
import { FiFilter } from "react-icons/fi";
import { MdMapsHomeWork } from "react-icons/md";
import { BsGearWideConnected } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { FaInfoCircle } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { RiFileExcel2Fill } from "react-icons/ri";
import { BiPurchaseTag } from "react-icons/bi";
import { GoGraph } from "react-icons/go";
import { HiOutlineReceiptTax } from "react-icons/hi";
import { TbReportAnalytics } from "react-icons/tb";
import { TbReportSearch } from "react-icons/tb";
import { TbBookDownload } from "react-icons/tb";
import { MdOutlineRequestPage } from "react-icons/md";
import { FaWallet } from "react-icons/fa";
import { FaList } from "react-icons/fa";
import { MdOutlineMailOutline } from "react-icons/md";
import { TbCameraPlus } from "react-icons/tb";

export const reactIcons = {
  circleclose: <IoIosCloseCircle />,
  camera: <TbCameraPlus />,
  user: <FaUser />,
  save: <FiSave />,
  logout: <BiLogOutCircle />,
  dollar: <BiDollarCircle />,
  list: <AiOutlineUnorderedList />,
  arrowleft: <BiChevronLeft />,
  arrowright: <BiChevronRight />,
  arrowDown: <BiChevronDown />,
  arrowUp: <BiChevronUp />,
  dashboard: <MdDashboard />,
  setting: <AiFillSetting />,
  edit: <MdEdit />,
  delete: <MdDelete />,
  manage: <MdOutlineManageAccounts />,
  gift: <FaGift />,
  star: <AiOutlineStar />,
  starFill: <FaStar />,
  fillstar: <AiFillStar />,
  eyeVisible: <AiFillEye />,
  eyeInVisible: <AiFillEyeInvisible />,
  close: <IoMdClose />,
  copy: <FaRegCopy />,
  handShake: <FaHandsHelping />,
  timeline: <FcTimeline />,
  transactions: <GrTransaction />,
  request: <BiGitPullRequest />,
  flag: <FaFlag />,
  qrCode: <FaQrcode />,
  account: <MdAccountBox />,
  upload: <RiUpload2Line />,
  more: <FiMoreVertical />,
  moreItems: <IoMdMore />,
  location: <MdMyLocation />,
  process: <VscServerProcess />,
  blockReport: <FaRegFileAlt />,
  report: <TbReportSearch />,
  dots: <BsThreeDotsVertical />,
  search: <FiSearch />,
  info: <MdOutlineInfo />,
  infoFill: <FaInfoCircle />,
  filter: <FiFilter />,
  franchise: <MdMapsHomeWork />,
  gear: <BsGearWideConnected />,
  login: <FiLogIn />,
  excell: <RiFileExcel2Fill />,
  purchase: <BiPurchaseTag />,
  check: <FaCheck />,
  sale: <GoGraph />,
  gst: <HiOutlineReceiptTax />,
  tds: <TbReportAnalytics />,
  withdraw: <TbBookDownload />,
  gasFees: <FaGasPump />,
  link: <FaExternalLinkAlt />,
  withdrawReq: <MdOutlineRequestPage />,
  wallet: <FaWallet />,
  logs: <FaList />,
  emailLog: <MdOutlineMailOutline />
};
